<template>
<svg data-svg-lvl-2="edge-top" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430">
<PreviewLayersEdgeTopBaseH2L :params="params" v-if="!params.isFlap7" />
<PreviewLayersEdgeTopBaseH2L_F7 :params="params" v-if="params.isFlap7" />
<PreviewLayersEdgeTopSliceH2L :params="params" v-if="!params.isFlap7" />
<PreviewLayersEdgeTopSliceH2L_F7 :params="params" v-if="params.isFlap7" />
<component :is="`PreviewLayersEdgeTopFlapF${params.flapComponent}`" :params="params" v-if="params.flapComponent" />
</svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>